export default {
  GET_DISCOUNTS: "GET_DISCOUNTS",
  ADD_OR_UPDATE_DISCOUNT: "ADD_OR_UPDATE_DISCOUNT",
  DELETE_DISCOUNT: "DELETE_DISCOUNT",
  GET_DISCOUNT_BY_ID: "GET_DISCOUNT_BY_ID",
};
